module.exports = __webpack_public_path__ + "img/Frame 1143one2.b88f9178.svg";